/* globals OAO, jimdoData */
module.exports = {
    init: function() {
        //TODO: here we should move the init code from surveyScriptLoader.js
    },

    show: function(whatToLoad, fromWhere) {
        //TODO: this should be refactored to init the OAO object.
        if (OAO && OAO.survey && OAO.survey.isLoaded) {
            OAO.survey.openSurvey(whatToLoad, fromWhere);
        }
    },
    closeOpenedWindows: function() {
        diy.editor.siteadmin.api.close();
    },

    showFromPublishCongratulations: function(closeOpenedWindows) {
        if (closeOpenedWindows === true) {
            this.closeOpenedWindows();
        }
        this.show('feedback', 'diyFirstPublish');
    },

    isSurveyEnabled: function() {
        return (jimdoData.surveyData.countryCode === 'de' ||
        jimdoData.surveyData.countryCode === 'us' ||
        jimdoData.surveyData.countryCode === 'uk');
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/survey/survey.js
 ** module id = 713
 ** module chunks = 0
 **/